var EqRenewalTypeNode = {
  REMPLACEMENT: 0,
  RESTITUTION: 1,
};

module.exports = EqRenewalTypeNode;
